import React, {useEffect, useState } from "react";
import { getMyAttendances } from "../../utils/helper";
import Loader from "../../utils/Loader";

export default function KPDs() {
    const [attendances, setMyAttendances] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getMyAttendances()
            .then((res) => { 
                if(res.data.success){
                    setMyAttendances(res.data.data);  
                }
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => { 
                console.log(err.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    return (
        <>
            {/* <div className="spur-card-menu"><button onClick={()=> {}} className="pull-right btn topbtn btn-primary">CHANGE VIEW</button></div> */}
            
            <h1 className="dash-title">Attendance Management</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">

                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">My Attendance Records</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && attendances && attendances) ?  <>
                                    <div className="table-responsive">
                                        {(attendances && attendances.length > 0) ? 
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr>
                                                <th>SN</th>
                                                <th>Date</th>
                                                <th>ClockIn Location</th>
                                                <th>Latitude</th>
                                                <th>Longitude</th>
                                                <th>Week</th>
                                                <th>TimeIn</th>
                                                <th align="center">TimeOut</th>
                                            </tr></thead>
                                            <tbody>
                                                {attendances && attendances.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.date && row?.date}</td>
                                                        <td>
                                                                {row.location && row.location}
                                                            </td>
                                                            <td align="center">
                                                                {row.latitude && row.latitude}
                                                            </td>
                                                            <td align="center">
                                                                {row.longitude && row.longitude}
                                                            </td>
                                                            <td>
                                                                {row.week}
                                                            </td>
                                                            <td><span className={row.timeIn >= "8:30:00 AM" ? `badge badge-danger` : `badge badge-success`}>
                                                                {row.timeIn} </span>
                                                            </td>
                                                            <td>{row.timeOut ? row.timeOut : "-- • --"}
                                                            </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No KPD has been set up for you yet.</div> }
                                    </div>
                                    </>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
